export default __webpack_public_path__ + "static/media/gabriel-vinderola@2x.c746391c.png";